import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/tcDash.css";
import Slider from "../../pages/homepage/Slider";
import TcNav from "./TcNav";

// Header component represents the header section of the page
function TcDashboard() {
  const authString = localStorage.getItem("user");
  const auth = authString ? JSON.parse(authString) : [];
  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const [counts, setCounts] = useState({
    totalCases: 0,
    unresolvedCases: 0,
    requestedCases: 0,
  });

  const getCounts = async () => {
    try {
      const response = await fetch("http://localhost:8000/counting", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json(); // Move this line after the check for response.ok
      // Check if 'result' contains a property named 'total_columns'
      if (result) {
        console.warn(result);
        setCounts(result);
      } else {
        console.error("Invalid response format:", result);
        // Handle the case where the response does not have the expected structure
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect hook to automatically fetch data when the component mounts
  useEffect(() => {
    getCounts();
  }, []);

  // console.warn(totalCases);

  return (
    <div id="root">
      <TcNav />
      <main className="p-5 text-white">
        <div className="woo w-100 mt-5 py-2 border rounded p-5">
          <img src="/user.png" alt="User Icon" className="mt-3" />
          <p>Name:{auth[0].name}</p><hr className="text-white" />
          <p>Email: {auth[0].email}</p>
          <hr className="text-white" />

          <p>
            Police Id: {auth[0].policeID}
          </p>
          <hr className="text-white" />

          <p>
            Station: {auth[0].policeStation}
          </p>
        </div>
        {/* cards */}
        <h3 className="text-white mt-5 text-center">Case Summary</h3>
        <div class="row row-cols-1 row-cols-md-3 g-4 mt-2 ">
          <div class="col">
            <div class="card border-dark mb-3">
              <div class="card-body">
                <h5 class="card-title text-white">{counts.total_columns}</h5>
                <hr className="text-white" />
                <p class="card-text text-white">
                  Total No of Cases
                  {counts.total_columns ? (
                    <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                      <span class="visually-hidden">New alerts</span>
                    </span>
                  ) : (
                    <span class="visually-hidden">New alerts</span>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-dark mb-3">
              <div class="card-body">
                <h5 class="card-title text-white">
                  {counts.total_unresolved_cases}
                </h5>
                <hr className="text-white" />
                <p class="card-text text-white">
                  No Unresolved Cases
                  {counts.total_unresolved_cases ? (
                    <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                      <span class="visually-hidden">New alerts</span>
                    </span>
                  ) : (
                    <span class="visually-hidden">New alerts</span>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-dark mb-3 ">
              <div class="card-body position-relative">
                <h5 class="card-title text-white">
                  {counts.total_requested_cases}
                </h5>
                <hr className="text-white" />
                <p class="card-text text-white">
                  No of Case Requests
                  {counts.total_requested_cases ? (
                    <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                      <span class="visually-hidden">New alerts</span>
                    </span>
                  ) : (
                    <span class="visually-hidden">New alerts</span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer className="wow">
        <Slider />
      </footer>
    </div>
  );
}

export default TcDashboard;
